module.exports = __webpack_public_path__ + "static/media/top112.e02b2c40.png";